import React, { useEffect, useState } from 'react'


export default function STPSeweragePreventiveQualityWardWise_A_Data({ tableData, DeletePopupShow }) {

    return (
        <div>

            <div className="row mob_table table-responsive pt-1">
                <table id="totalordergenerated"
                    cellPadding="0"
                    cellSpacing="0"
                    border="0"
                    className="table table-bordered">

                    <thead>
                        <tr>
                            <th rowSpan="2" className="sr_no_col">Sr No.</th>
                            <th rowSpan="2" className="sr_no_col">Date</th>
                            <th colSpan="2" className='new_grid'>Flow_MLD</th>
                            <th colSpan="2" className='new_grid'>COD_Mg_L</th>
                            <th colSpan="2" className='new_grid'>BOD_Mg_L</th>
                            <th colSpan="2" className='new_grid'>TSS_Mg_L</th>
                            <th colSpan="2" className='new_grid'>NH4-N_Mg_L</th>
                            <th colSpan="2" className='new_grid'>pH</th>
                            <th colSpan="2" className='new_grid'>Chlorine_Mg_L</th>
                            {/* <th rowSpan="2">Action</th> */}
                        </tr>
                        <tr>
                            <th>inlet</th>
                            <th>outlet</th>
                            <th>inlet</th>
                            <th>outlet</th>
                            <th>inlet</th>
                            <th>outlet</th>
                            <th>inlet</th>
                            <th>outlet</th>
                            <th>inlet</th>
                            <th>outlet</th>
                            <th>inlet</th>
                            <th>outlet</th>
                            <th>inlet</th>
                            <th>outlet</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            tableData && tableData.length > 0 ? tableData.map((item) => (
                                <tr>
                                    <td style={{ textAlign: "center" }}>{item.srNo ? item.srNo : '-'}</td>
                                    <td>{item.readingDate ? item.readingDate : '-'}</td>
                                    <td>{item.flow_MLD_Inlet ? (item.flow_MLD_Inlet).toFixed(2) : '0'}</td>
                                    <td>{item.flow_MLD_Outlet ? (item.flow_MLD_Outlet).toFixed(2) : '0'}</td>
                                    <td>{item.coD_Mg_L_Inlet ? (item.coD_Mg_L_Inlet).toFixed(2) : '0'}</td>
                                    <td>{item.coD_Mg_L_Outlet ? (item.coD_Mg_L_Outlet).toFixed(2) : '0'}</td>
                                    <td>{item.boD_Mg_L_Inlet ? (item.boD_Mg_L_Inlet).toFixed(2) : '0'}</td>
                                    <td>{item.boD_Mg_L_Outlet ? (item.boD_Mg_L_Outlet).toFixed(2) : '0'}</td>
                                    <td>{item.tsS_Mg_L_Inlet ? (item.tsS_Mg_L_Inlet).toFixed(2) : '0'}</td>
                                    <td>{item.tsS_Mg_L_Outlet ? (item.tsS_Mg_L_Outlet).toFixed(2) : '0'}</td>
                                    <td>{item.nH4_N_Mg_L_Inlet ? (item.nH4_N_Mg_L_Inlet).toFixed(2) : '0'}</td>
                                    <td>{item.nH4_N_Mg_L_Outlet ? (item.nH4_N_Mg_L_Outlet).toFixed(2) : '0'}</td>
                                    <td>{item.pH_Inlet ? (item.pH_Inlet).toFixed(2) : '0'}</td>
                                    <td>{item.pH_Outlet ? (item.pH_Outlet).toFixed(2) : '0'}</td>
                                    <td>{item.chlorinE_Mg_L_Inlet ? (item.chlorinE_Mg_L_Inlet).toFixed(2) : '0'}</td>
                                    <td>{item.chlorinE_Mg_L_Outlet ? (item.chlorinE_Mg_L_Outlet).toFixed(2) : '0'}</td>

                                </tr>
                            ))
                                :
                                <></>
                        }
                    </tbody>
                </table>

            </div>
        </div>
    )
}